import { supabase, isSupabaseConfigured } from './supabase';
import manifest from '../data/portfolioManifest.json';

// Redigerbara texter, med etiketter för admin. Ordningen styr visningen i admin.
export const TEXT_FIELDS = [
  { key: 'hero_title', label: 'Startsidan – huvudrubrik', multiline: false },
  { key: 'hero_title_accent', label: 'Startsidan – rubrikens andra del (accentfärg)', multiline: false },
  { key: 'hero_subtitle', label: 'Startsidan – underrubrik', multiline: true },
  { key: 'about_lead', label: 'Om mig – inledande mening', multiline: true },
  { key: 'about_text', label: 'Om mig – brödtext', multiline: true },
];

export const fallbackTexts = { ...manifest.siteTexts };

// Hämta alla texter som { key: value }, med fallback för de som saknas i DB.
export const fetchSiteTexts = async () => {
  if (!isSupabaseConfigured) return { ...fallbackTexts };
  try {
    const { data, error } = await supabase.from('site_texts').select('*');
    if (error) throw error;
    const out = { ...fallbackTexts };
    for (const row of data || []) out[row.key] = row.value;
    return out;
  } catch (err) {
    console.error('Kunde inte hämta texter:', err.message);
    return { ...fallbackTexts };
  }
};

export const updateSiteText = async (key, value) => {
  if (!isSupabaseConfigured) throw new Error('Supabase är inte konfigurerat.');
  const { error } = await supabase
    .from('site_texts')
    .upsert({ key, value, updated_at: new Date().toISOString() }, { onConflict: 'key' });
  if (error) throw error;
};
